/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Finish_Embed_LinkInputs */

const en_register_onboarding_finish_embed_link = /** @type {(inputs: Register_Onboarding_Finish_Embed_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed Buchungsheld`)
};

const de_register_onboarding_finish_embed_link = /** @type {(inputs: Register_Onboarding_Finish_Embed_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchungsheld einbinden`)
};

/**
* | output |
* | --- |
* | "Embed Buchungsheld" |
*
* @param {Register_Onboarding_Finish_Embed_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_finish_embed_link = /** @type {((inputs?: Register_Onboarding_Finish_Embed_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Finish_Embed_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_finish_embed_link(inputs)
	return en_register_onboarding_finish_embed_link(inputs)
});